const COOKIE_CONSENT_KEY = 'fm-cookie-consent-v1';
export function getCookieConsentChoice() {
    try {
        const value = localStorage.getItem(COOKIE_CONSENT_KEY);
        if (value === 'accepted' || value === 'rejected') {
            return value;
        }
        return null;
    }
    catch {
        return null;
    }
}
export function setCookieConsentChoice(choice) {
    try {
        localStorage.setItem(COOKIE_CONSENT_KEY, choice);
    }
    catch {
        // ignore
    }
}
export function clearCookieConsentChoice() {
    try {
        localStorage.removeItem(COOKIE_CONSENT_KEY);
    }
    catch {
        // ignore
    }
}
//# sourceMappingURL=cookie-consent-storage.js.map